import React from "react";
import * as Styled from "./styled.jsx";

import metamask from "./assets/ic-metamask.svg";
import coinbase from "./assets/ic-coinbase.svg";
import walletconnect from "./assets/ic-walletconnect.svg";

import { useDispatch } from "react-redux";
import WalletKind from "../../reducers/wallet/walletKind";
import { connect } from "../../reducers/wallet";
import Modal from "../Modal";

const IconifiedButton = {
  metamask: { title: "MetaMask", icon: metamask },
  coinbase: { title: "Coinbase", icon: coinbase },
  walletconnect: { title: "WalletConnect", icon: walletconnect },
};

function Wallet(props) {
  const dispatch = useDispatch();

  const handleMetamaskConnect = () => {
    dispatch(connect(WalletKind.metamask));
  };

  const handleCoinbaseConnect = () => {
    dispatch(connect(WalletKind.coinbase));
  };

  const handleWalletconnectConnect = () => {
    dispatch(connect(WalletKind.walletconnect));
  };
  return (
    <Modal onClose={props.onClose}>
      <Styled.Title>Connect your wallet</Styled.Title>
      <Styled.IconifiedButtonsContainer>
        <Styled.IconifiedButton style={IconifiedButton.metamask} onClick={handleMetamaskConnect} />
        <Styled.IconifiedButton style={IconifiedButton.coinbase} onClick={handleCoinbaseConnect} />
        <Styled.IconifiedButton style={IconifiedButton.walletconnect} onClick={handleWalletconnectConnect} />
      </Styled.IconifiedButtonsContainer>
    </Modal>
  );
}

export default Wallet;
